import React, { useState, useEffect } from 'react';
import { GoBackTestDriveLoadingIcon } from '@util/svgicon';
import frodobotgif from '@videos/frodobots.gif';
import Modal from 'react-modal';
import RulesModel from '../Modal/RulesModel';
import { useRouter } from 'next/router';
import { OpenWorldLoadingScreenData, TestDriveLoadingScreenData, getParameterByName, getModeByUrl } from '@util/config';
import { safeLocalStorage } from '@utils/localstorage';
import * as actionTypes from '@redux/actionTypes';
import { useDispatch, useSelector } from 'react-redux';
import { rideTerminate } from '@services/api';
const isBrowser = typeof window !== 'undefined';

const OpenWorldTestDriveLoadingScreen = () => {
	const router = useRouter();
	const dispatch = useDispatch();
	const [title, setTitle] = useState(false);
	const keyboradKey = safeLocalStorage.getItem(`keyboradKey`)
	const RemoteKey = safeLocalStorage.getItem(`RemoteKey`)
	const WheelKey = safeLocalStorage.getItem(`WheelKey`)
	const drivingBot = safeLocalStorage.getItem('drivingBot')
	const tournamentData = safeLocalStorage.getItem('tournamentData')
	const torunamentId = getParameterByName('tournamentId') || getParameterByName('tournamentid') || '';
	const user = useSelector((state) => state?.setUserDetails?.user);
	const rulesOpenModel = useSelector((state) => state.loadingSpinner.ruleModel);
	const isAppDomain = useSelector((state) => state.appConnections.isAppDomain);
	const createRide = useSelector((state) => state.missionDetail.createRide);
	const testDriveRideId = useSelector((state) => state.testDriveDetails.testDriveRideId);
	const rideId = createRide?.id || testDriveRideId;

	const loadingScreenData = getModeByUrl() === 'playgame' ? TestDriveLoadingScreenData : OpenWorldLoadingScreenData

	useEffect(() => {
		const openworldLoadingScreenElement = document.getElementById('openworldLoadingScreen');
		if (isAppDomain === 'my' && openworldLoadingScreenElement) {
			openworldLoadingScreenElement.style.display = 'none';
		}
	}, [isAppDomain]);

	const handleCheckboxChange = () => {
		if(title) {
			setTitle(false);
		} else {
			setTitle(true);
		}
	};

	const rulesModelHandler = () => {
		dispatch({
			type: actionTypes.RULES_MODEL,
			payload: true
		});
		const openworldLoadingScreenElement = document.getElementById('openworldLoadingScreen');
		if (openworldLoadingScreenElement) {
			openworldLoadingScreenElement.style.display = 'none';
		}
	};

	const closeRulesModelHandler = () => {
		dispatch({
			type: actionTypes.RULES_MODEL,
			payload: false
		});
		const openworldLoadingScreenElement = document.getElementById('openworldLoadingScreen');
		if (openworldLoadingScreenElement) {
			openworldLoadingScreenElement.style.display = 'block';
		}
	};

	const gotoDriveHandler = () => {
		const openworldLoadingScreenElement = document.getElementById('openworldLoadingScreen');
		if (openworldLoadingScreenElement) {
			openworldLoadingScreenElement.style.display = 'none';
		}
	};

	const goBackHandler = () => {
		rideTerminatedHandler();
		if (getModeByUrl === 'playgame') {
			if (keyboradKey) {
				router.push(`/testdrivekeyboardkeybinding`);
			} else if (RemoteKey) {
				router.push(`/testdrivecontrolremotekeybinding`);
			} else if (WheelKey) {
				router.push(`/testdrivewheelkeybinding`);
			}
		} else {
			if (keyboradKey) {
				router.push(`/openworldkeyboardkeybindings`);
			} else if (RemoteKey) {
				router.push(`/openworldcontrolremotekeybindings`);
			} else if (WheelKey) {
				router.push(`/openworldwheelkeybindings`);
			}
		}
	};

	const rideTerminatedHandler = async () => {
		await rideTerminate(rideId)
		if (isBrowser) {
			safeLocalStorage.clearLocalStorageItems([
				'selectControllerName',
				'headlight',
				`ride_sequence_${drivingBot?.deviceId}`,
				`rideId_${drivingBot?.deviceId}`,
				`ride_${drivingBot?.deviceId}`,
				`sessionId_${drivingBot?.deviceId}`,
				`bot_status_${drivingBot?.deviceId}`,
				`location_${drivingBot?.deviceId}`,
				`tournamentId_${torunamentId}`,
				`drivingBot`,
				`agoratoken_${tournamentData?.deviceId}`,
				`keyBinding_${user?.id}`,
				`tournamentData`,
				`keyboradKey`,
				`WheelKey`,
				`RemoteKey`
			]);
		}
	}

	return (
		<div
			className="w-full h-full overflow-auto bg-[#111] p-[36px] absolute z-[10]"
			id="openworldLoadingScreen"
		>
			<div className="flex w-[130px] pl-[8px] pr-[12px] py-[6px] gap-[6px] rounded-[1000px] border-[1px] border-[solid] border-[#737373] bg-[#000]">
				<button
					className="flex pl-[8px] pr-[12px] py-[6px] items-start gap-[6px] rounded-[1000px] border-[1px] border-[solid] border-[#737373] bg-[#000]"
					onClick={goBackHandler}
				>
					<GoBackTestDriveLoadingIcon />
					<p className="text-[#FAFAFA] text-[16px] not-italic font-bold leading-[normal] tracking-[-0.32px]">Go back</p>
				</button>
			</div>
			<div className="flex flex-col gap-[20px]">
				<div className="flex justify-center">
					<div style={{ width: '100px', height: '100px' }}>
						<img src={frodobotgif} />
					</div>
				</div>
				<div className="flex flex-col items-center gap-[16px]">
					<p className="text-[#FAFAFA] text-center text-[28px] not-italic font-semibold leading-[28px] tracking-[-1.68px]">
						Getting your drive ready!
					</p>
					<p className="text-[#FAFAFA] text-center text-[28px] not-italic font-semibold leading-[28px] tracking-[-1.68px]">
						Please acknowledge the below rules by clicking the checkbox on each of them.
					</p>
				</div>
				<div className="flex justify-center gap-[24px] w-full">
					<div className="flex p-[24px] flex-col items-center rounded-[32px] bg-[#000] w-[90%]">
						<div className="flex justify-center gap-[24px] flex-wrap">
							{loadingScreenData.map((i, index) => (
								<div
									className="flex w-[49%] p-[24px] justify-center items-center gap-[24px] rounded-[24px] bg-[#111]"
									style={{ border: title ? `` : `2px solid #FCF552` }}
									key={index}
								>
									<div>{i.icon}</div>
									<div className="flex flex-col items-start gap-[8px]">
										<p className="text-[#FAFAFA] text-[28px] not-italic font-semibold leading-[28px] tracking-[-1.68px]">
											{i.title}
										</p>
										<p className="text-[rgba(250,_250,_250,_0.75)] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]">
											{i.description}
										</p>
									</div>
								</div>
							))}
							<div className="flex w-[30%] p-[14px] justify-center items-center gap-[24px] rounded-[24px] bg-[#111]">
								<div className="flex flex-col items-start gap-[8px]">
									<p className="text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[28px] tracking-[-1.68px]">
										I agree to the above
									</p>
								</div>
								<div>
									<input
										type="checkbox"
										checked={title}
										onChange={handleCheckboxChange}
										className="w-[32px] h-[32px]"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="flex justify-center gap-[10px]">
					<button
						className="flex w-[400px] h-[56px] max-w-[400px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] border-[1px] bg-[#000]"
						onClick={rulesModelHandler}
					>
						<p className="text-[#FAFAFA] text-[20px] not-italic font-bold leading-[25px] tracking-[-0.8px]">
							Learn more about rules
						</p>
					</button>
					<button
						className="flex w-[400px] h-[56px] max-w-[400px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] border-[1px]  bg-[#25BD66]"
						style={{ opacity: title ? 1 : 0.4 }}
						disabled={title ? false : true}
						onClick={gotoDriveHandler}
					>
						<p className="text-[#FAFAFA] text-[20px] not-italic font-bold leading-[25px] tracking-[-0.8px]">
							Good to proceed!
						</p>
					</button>
				</div>
			</div>
			<Modal
				isOpen={rulesOpenModel}
				ariaHideApp={false}
				className="absolute top-2/4 left-2/4 -translate-x-1/2 -translate-y-1/2 w-[100%] h-[100%] bg-[#FAFAFA]"
				onRequestClose={closeRulesModelHandler}
			>
				<RulesModel closeRulesModelHandler={closeRulesModelHandler} />
			</Modal>
		</div>
	);
};

export default OpenWorldTestDriveLoadingScreen;
